import React, { useLayoutEffect, ComponentPropsWithoutRef, FC } from "react";
import cn from "classnames";
import { useVisibility } from "src/hooks/useVisibility";

const SHOW_DELAY = 0; //ms

interface Props extends ComponentPropsWithoutRef<"div"> {
  withAnimation: boolean;
}
export const StepWrapper: FC<Props> = ({
  children,
  className,
  withAnimation,
}) => {
  const { isVisible, show } = useVisibility(!withAnimation, SHOW_DELAY);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(show, []);

  return (
    <div
      className={cn(
        "flex flex-col gap-4 px-5 py-4 rounded-2xl bg-blue-base transition-all duration-300 md:p-10 lg:p-15 lg:gap-7",
        {
          "opacity-0 scale-95 -translate-y-1/3": !isVisible && withAnimation,
          "opacity-100 scale-100 translate-y-0 ": isVisible && withAnimation,
        },

        className
      )}
    >
      {children}
    </div>
  );
};
